import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'sc-field-repeat',
  templateUrl: './field-repeat.component.html',
  styleUrls: ['./field-repeat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldRepeatComponent extends FieldArrayType {}
